import { React } from 'react';
import '../Assets/css/scrollbar.css';
import sampleLogo from '../Assets/Images/HHG_Final_Logo.png';
import camaco from '../Assets/Images/amvian.png';
import LT from '../Assets/Images/L&T.svg';
import hitachi from '../Assets/Images/HITACHI.svg';
import recaro from '../Assets/Images/RECARO.svg'
import THERMAX_Logo from '../Assets/Images/THERMAX-2.svg'
import volvo from '../Assets/Images/VOLVO-1.svg'



const ScrollBar = () => {
    return(
        <div class="elementor-element elementor-element-8d1e4b7 e-con-full e-flex e-con e-parent" data-id="8d1e4b7" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;full&quot;}" data-core-v316-plus="true"  >
		    <div class="gradient-background elementor-element elementor-element-818fc86 e-con-full e-flex e-con e-child" data-id="818fc86" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
		        <div class="elementor-element elementor-element-d5614bb e-con-full e-flex e-con e-child" data-id="d5614bb" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
		            <div class="elementor-element elementor-element-7dd0145 e-con-full e-flex e-con e-child" data-id="7dd0145" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				        <div class="elementor-element elementor-element-74b553b elementor-widget elementor-widget-spacer" data-id="74b553b" data-element_type="widget" data-widget_type="spacer.default">
				            <div class="elementor-widget-container">
				                <div class="elementor-spacer">
			                        <div class="elementor-spacer-inner"></div>
		                        </div>
				            </div>
				        </div>
				    </div>
		            <div class="elementor-element elementor-element-c04e9d9 e-con-full e-flex e-con e-child" data-id="c04e9d9" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				        <div class="elementor-element elementor-element-ca2b18f elementor-widget elementor-widget-spacer" data-id="ca2b18f" data-element_type="widget" data-widget_type="spacer.default">
				            <div class="elementor-widget-container">
					            <div class="elementor-spacer">
			                        <div class="elementor-spacer-inner"></div>
		                        </div>
				            </div>
				        </div>
				    </div>
				</div>
				<div class="elementor-element elementor-element-632faad elementor-widget elementor-widget-jkit_client_logo" data-id="632faad" data-element_type="widget" data-widget_type="jkit_client_logo.default">
				    <div class="elementor-widget-container">
			            <div  class="jeg-elementor-kit jkit-client-logo arrow-bottom-middle jeg_module_6_7_676b7978de97e"  data-id="jeg_module_6_7_676b7978de97e" data-settings="{&quot;autoplay&quot;:true,&quot;autoplay_speed&quot;:3500,&quot;autoplay_hover_pause&quot;:false,&quot;show_navigation&quot;:false,&quot;navigation_left&quot;:&quot;&lt;i aria-hidden=\&quot;true\&quot; class=\&quot;fas fa-angle-left\&quot;&gt;&lt;\/i&gt;&quot;,&quot;navigation_right&quot;:&quot;&lt;i aria-hidden=\&quot;true\&quot; class=\&quot;fas fa-angle-right\&quot;&gt;&lt;\/i&gt;&quot;,&quot;show_dots&quot;:false,&quot;arrow_position&quot;:&quot;bottom&quot;,&quot;responsive&quot;:{&quot;desktop&quot;:{&quot;items&quot;:&quot;6&quot;,&quot;margin&quot;:&quot;20&quot;,&quot;breakpoint&quot;:1025},&quot;tablet&quot;:{&quot;items&quot;:&quot;4&quot;,&quot;margin&quot;:&quot;15&quot;,&quot;breakpoint&quot;:768},&quot;mobile&quot;:{&quot;items&quot;:2,&quot;margin&quot;:&quot;20&quot;,&quot;breakpoint&quot;:0}}}">
                            <div class="client-list">
                                <div class="client-track">
                                    <div class="client-slider item ">
                                        <div class="image-list">
                                            <div class="content-image">
                                            <img decoding="async" src={camaco} className="main-image" alt="camaco" style={{ width: '280px', height: '200px' }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="client-slider item ">
                                        <div class="image-list">
                                            <div class="content-image">
                                                <img decoding="async" src={LT}  class="main-image" alt="l&T" style={{ width: '280px', height: '200px' }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="client-slider item ">
                                        <div class="image-list">
                                            <div class="content-image">
                                                <img decoding="async" src={hitachi}  class="main-image" alt="" style={{ width: '280px', height: '200px' }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="client-slider item ">
                                        <div class="image-list">
                                            <div class="content-image">
                                                <img decoding="async" src={recaro} class="main-image" alt="" style={{ width: '280px', height: '200px' }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="client-slider item ">
                                        <div class="image-list">
                                            <div class="content-image">
                                                <img decoding="async" src={THERMAX_Logo} class="main-image" alt="" style={{ width: '280px', height: '200px' }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="client-slider item ">
                                        <div class="image-list">
                                            <div class="content-image">
                                                <img decoding="async" src={volvo}  class="main-image" alt="" style={{ width: '280px', height: '200px' }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="client-slider item ">
                                        <div class="image-list">
                                            <div class="content-image">
                                                <img decoding="async" src={recaro}  class="main-image" alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            		</div>
				</div>
			</div>
		</div>
    )
}

export default ScrollBar;